import { useCallback, useMemo, type JSX } from 'react';
import { Divider } from '../../Divider/Divider';
import { GroupColumnMenuProps } from '../types';
import { GroupMenuWrapper } from '../styled';
import { MenuToggler } from './MenuToggler';

export const RestrictedGroupColumnMenu = ({
  groupName,
  columns,
  provider,
  className,
  checkboxVariant = 'critical',
}: GroupColumnMenuProps): JSX.Element => {
  const columnNames = useMemo(() => columns.map((col) => col.name), [columns]);

  const isGroupSelected = useMemo(() => {
    return provider.selectedColumns.includes(groupName);
  }, [provider.selectedColumns, groupName]);

  const handleSelectGroup = useCallback(() => {
    if (isGroupSelected) {
      const newSelection = provider.selectedColumns.filter(
        (name) => name !== groupName && !columnNames.includes(name)
      );
      provider.setSelectedColumns(newSelection);
    } else {
      const newSelection = [
        ...provider.selectedColumns.filter((name) => !columnNames.includes(name)),
        groupName,
      ];
      provider.setSelectedColumns(newSelection);
    }
  }, [isGroupSelected, provider, groupName, columnNames]);

  return (
    <GroupMenuWrapper className={className}>
      <MenuToggler
        name={groupName}
        open={false}
        checked={isGroupSelected}
        indeterminate={false}
        onSelectAllNone={handleSelectGroup}
        showToggler={false}
        checkboxVariant={checkboxVariant}
      />
      <Divider />
    </GroupMenuWrapper>
  );
};
